<button
  type="button"
  class="btn ellipsis"
  [disabled]="disabled"
  [matMenuTriggerFor]="singleSelectMenu"
  [matTooltip]="user | fullName"
  [matTooltipShowDelay]="1000"
>
  <ng-content></ng-content>
</button>

<mat-menu #singleSelectMenu="matMenu" class="user-info-dropdown">
  <ng-template matMenuContent="">
    <div class="user-logo">
      <craft-user-icon class="user-pic" [user]="user" [size]="'big'"></craft-user-icon>
      <div class="user-data ellipsis">
        <h3 class="user-author ellipsis">{{ user | fullName }}</h3>
        <div class="user-company ellipsis" *ngIf="user?.userType === 'company'">
          {{ $any(user).companyId | craftCompanyName | async }}
        </div>
      </div>
    </div>

    <div class="mat-mdc-menu-item email-block" *ngIf="user?.email">
      <span class="email ellipsis">{{ user!.email }}</span>
      <craft-copy-text-button class="copy" tooltipPosition="below" [text]="user!.email!">
        <craft-icon name="general--copy-md"></craft-icon>
      </craft-copy-text-button>
    </div>
  </ng-template>
</mat-menu>
